$(document).ready(function(){

    /* ================= TAB CLICK → SLIDE ================= */
    $(document).on('click', '.block__real-results-tab', function() {

        var $this = $(this);
        var targetClass = $this.data('product');

        var $wrapper = $this.closest('.container_content');
        var $slider = $wrapper.find('.block__real-results-tabs-container');

        // Active tab
        $wrapper.find('.block__real-results-tab').removeClass('active');
        $this.addClass('active');

        // Find slide index using class
        var $targetSlide = $slider.find('.' + targetClass);
        var slideIndex = $targetSlide.data('slick-index');

        if ($slider.hasClass('slick-initialized') && slideIndex !== undefined) {
            $slider.slick('slickGoTo', slideIndex);
        }
    });


    /* ================= SLICK INIT ================= */
    $(".block__real-results-tabs-container").each(function(){
        var $this = $(this);

        $this.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            nextArrow: $this.find(".block__ai-review-video-info-arrow"),
            fade: true,
            adaptiveHeight: true
        });
    });


    /* ================= BEFORE CHANGE (RESET VIDEO) ================= */
    $('.block__real-results-tabs-container').on('beforeChange', function () {

        $('.block__homereview-video-item').each(function(){
            var video = $(this).find("video")[0];

            if(video){
                video.pause();
                video.removeAttribute('controls');
                video.currentTime = 0;
            }

            $(this).find('.block__ai-review-video-boxplay').removeClass("hidden");
            $(this).find("video").removeAttr('style');
        });
    });


    /* ================= AFTER CHANGE ================= */
    $('.block__real-results-tabs-container').on('afterChange', function (event, slick, currentSlide) {

        var $slider = $(this);
        var $wrapper = $slider.closest('.container_content');

        
        var currentSlideEl = $(slick.$slides[currentSlide]);
        var classList = currentSlideEl.attr('class').split(/\s+/);

        var targetClass = classList.find(c => c.includes('block__real-results-product-tab_'));

        if (targetClass) {
            $wrapper.find('.block__real-results-tab').removeClass('active');
            $wrapper.find('.block__real-results-tab[data-product="' + targetClass + '"]').addClass('active');
        }

     
        $('.block__homereview-video-item').each(function(){
            var video = $(this).find("video")[0];

            if(video){
                video.pause();
                video.removeAttribute('controls');
            }

            $(this).find('.block__ai-review-video-boxplay').removeClass("hidden");
            $(this).find("video").removeAttr('style');
        });

      
        if($(window).width() > 1023){
            $('.block__ai-review-trusted-logos').css(
                'height',
                $('.block__real-results-tabs-container .slick-list').innerHeight()
            );

            $('.block__ai-review-trusted-logos-wrapper').css(
                'height',
                $('.block__ai-review-trusted-logos').innerHeight() - $('.block__ai-review-heading').innerHeight()
            );
        }
    });


    /* ================= VIDEO PLAY ================= */
    $(document).on("click",".block__ai-review-video-boxplay",function(){

        var $btn = $(this);
        var video = $btn.parents(".block__homereview-video-boxwrap").find("video")[0];

        $btn.addClass("hidden");

        if(video){
            $(video).attr("controls","true");
            video.play();
            video.muted = false;
            video.style.position = "relative";
            video.style.zIndex = "1";
        }
    });


    /* ================= SOUND TOGGLE ================= */
    $(document).on("click",".block__homereview-video-soundbtn",function(){

        var $btn = $(this);
        var video = $btn.parents(".block__homereview-video-boxwrap").find("video")[0];

        if(video){
            if(video.muted){
                $btn.addClass('sound-on');
                video.muted = false;
            } else {
                $btn.removeClass('sound-on');
                video.muted = true;
            }
        }
    });


    /* ================= FULLSCREEN FIX ================= */
    function refreshSlickIfNotFullscreen() {
        if (!document.fullscreenElement &&
            !document.webkitFullscreenElement &&
            !document.mozFullScreenElement &&
            !document.msFullscreenElement) {

            setTimeout(function() {
                $(".block__real-results-tabs-container").slick('refresh');
            }, 500);
        }
    }

    document.addEventListener("fullscreenchange", refreshSlickIfNotFullscreen);
    document.addEventListener("webkitfullscreenchange", refreshSlickIfNotFullscreen);
    document.addEventListener("mozfullscreenchange", refreshSlickIfNotFullscreen);
    document.addEventListener("msfullscreenchange", refreshSlickIfNotFullscreen);

});